module.exports = __webpack_public_path__ + "media/images/premium/premium-card-po-rt-248aea02ab11da267db63bd36b7035b0.svg";